
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';

export const metadata = {
  toc: true,
  layout: 'guide',
  source: 'error',
  description: 'Guide to understanding and troubleshooting ASSET_REPORT_ERROR and ASSET_REPORT_WARNING types, which identify a class of issues related to the creation of an Asset Report.'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const ErrorReference = makeShortcode("ErrorReference");
const Checkbox = makeShortcode("Checkbox");
const Callout = makeShortcode("Callout");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title='Assets errors' subtitle='Guide to troubleshooting Assets errors' mdxType="Header" />
    <h4 {...{
      "id": "product_not_enabled"
    }}><strong parentName="h4">{`PRODUCT_NOT_ENABLED`}</strong></h4>
    <ErrorReference type='ASSET_REPORT_ERROR' error='PRODUCT_NOT_ENABLED' subtitle='' server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`One or more of the Items in the Asset Report was not initialized with the Assets product. Unlike some products, Assets cannot be initialized "on-the-fly" via the API; they must be initialized through Link, either during the initial Link flow or by adding Assets to an existing Item via `}<a parentName="li" {...{
            "href": "/docs/link/update-mode"
          }}>{`update mode`}</a>{`.`}</li>
        <li parentName="ul">{`The Assets product was deauthorized for one or more Items in the Asset Report — for example, if the user began an `}<a parentName="li" {...{
            "href": "/docs/link/update-mode"
          }}>{`update mode`}</a>{` session to add Assets but did not complete it.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox checklistId='PRODUCT_NOT_ENABLED' mdxType="Checkbox">
        <p>{`Make sure to include `}<inlineCode parentName="p">{`assets`}</inlineCode>{` in the list of products to initialize the Item for during Link, then have your user re-link the Item.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "data_unavailable"
    }}><strong parentName="h4">{`DATA_UNAVAILABLE`}</strong></h4>
    <ErrorReference type='ASSET_REPORT_ERROR' error='DATA_UNAVAILABLE' subtitle='' server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-1"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`One or more of the Items in the Asset Report has experienced an error.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-1"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox checklistId='DATA_UNAVAILABLE' mdxType="Checkbox">
        <p>{`Check the `}<inlineCode parentName="p">{`causes`}</inlineCode>{` field for a detailed breakdown of errors, then follow the troubleshooting steps for any errors found.`}</p>
      </Checkbox>
      <Checkbox checklistId='DATA_UNAVAILABLE_2' mdxType="Checkbox">
        <p>{`If the `}<inlineCode parentName="p">{`causes`}</inlineCode>{` field is not present, use `}<inlineCode parentName="p">{`/item/get`}</inlineCode>{` to query the Items in the Asset Report for errors, then follow the troubleshooting steps for any errors found.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "product_not_ready"
    }}><strong parentName="h4">{`PRODUCT_NOT_READY`}</strong></h4>
    <ErrorReference type='ASSET_REPORT_ERROR' error='PRODUCT_NOT_READY' subtitle='' server mdxType="ErrorReference">
      <Callout mdxType="Callout">
        <p>{`Note that this error should not be confused with the `}<a parentName="p" {...{
            "href": "/docs/errors/item/#product_not_ready"
          }}><inlineCode parentName="a">{`PRODUCT_NOT_READY`}</inlineCode></a>{` error of type `}<inlineCode parentName="p">{`ITEM_ERROR`}</inlineCode>{`, which has different causes.`}</p>
      </Callout>
      <h5 {...{
        "id": "common-causes-2"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul"><inlineCode parentName="li">{`/asset_report/get`}</inlineCode>{` or `}<inlineCode parentName="li">{`/asset_report/pdf/get`}</inlineCode>{` was called before the Asset Report generation completed.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-2"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox checklistId='PRODUCT_NOT_READY' mdxType="Checkbox">
        <p>{`Listen for the `}<a parentName="p" {...{
            "href": "/docs/api/products/assets/#product_ready"
          }}><inlineCode parentName="a">{`PRODUCT_READY`}</inlineCode></a>{` webhook and wait to call `}<inlineCode parentName="p">{`/asset_report/get`}</inlineCode>{` or `}<inlineCode parentName="p">{`/asset_report/pdf/get`}</inlineCode>{` until that webhook has been fired.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "asset_report_generation_failed"
    }}><strong parentName="h4">{`ASSET_REPORT_GENERATION_FAILED`}</strong></h4>
    <ErrorReference type='ASSET_REPORT_ERROR' error='ASSET_REPORT_GENERATION_FAILED' subtitle='' server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-3"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`Plaid is experiencing temporary difficulties generating Asset Reports.`}</li>
        <li parentName="ul">{`The Asset Report was too large to generate.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-3"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox checklistId='GENERATION_FAILED_0' mdxType="Checkbox">
        <p>{`Check the `}<inlineCode parentName="p">{`error_message`}</inlineCode>{` field for details on the cause of the error.`}</p>
      </Checkbox>
      <Checkbox checklistId='GENERATION_FAILED_1' mdxType="Checkbox">
        <p>{`If the `}<inlineCode parentName="p">{`error_message`}</inlineCode>{` indicates the Asset Report was too large, try requesting a shorter date range in the Asset Report. `}</p>
      </Checkbox>
      <Checkbox checklistId='GENERATION_FAILED' mdxType="Checkbox">
        <p>{`Try creating the Asset Report again later.`}</p>
      </Checkbox>
      <p>{`If the error persists, please submit a `}<a parentName="p" {...{
          "href": "https://dashboard.plaid.com/support/new/"
        }}>{`Support`}</a>{` ticket.`}</p>
    </ErrorReference>
    <h4 {...{
      "id": "invalid_parent"
    }}><strong parentName="h4">{`INVALID_PARENT`}</strong></h4>
    <ErrorReference type='ASSET_REPORT_ERROR' error='INVALID_PARENT' subtitle='' server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-4"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`An endpoint that creates a copy or modified copy of an Asset Report (such as `}<inlineCode parentName="li">{`/asset_report/filter`}</inlineCode>{` or `}<inlineCode parentName="li">{`/asset_report/audit_copy/create`}</inlineCode>{`) was called, but the original Asset Report does not exist, either because it was never successfully created, failed to generate, or was deleted.`}</li>
        <li parentName="ul">{`The original Asset Report is still being generated.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-4"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox checklistId='INVALID_PARENT' mdxType="Checkbox">
        <p>{`Re-create the original Asset Report and re-try the endpoint call on the new Asset Report.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "insights_previously_not_enabled"
    }}><strong parentName="h4">{`INSIGHTS_PREVIOUSLY_NOT_ENABLED`}</strong></h4>
    <ErrorReference type='ASSET_REPORT_ERROR' error='INSIGHTS_PREVIOUSLY_NOT_ENABLED' subtitle='' server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-5"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul"><inlineCode parentName="li">{`/asset_report/get`}</inlineCode>{` was called with `}<inlineCode parentName="li">{`include_insights`}</inlineCode>{` set to `}<inlineCode parentName="li">{`true`}</inlineCode>{` by a Plaid developer account that is currently enabled for Asset Reports with Insights, but was not enabled at the time that the report was created.`}</li>
      </ul>
      <Checkbox checklistId='INSIGHTS_NOT_ENABLED' mdxType="Checkbox">
        <p>{`Re-create the Asset Report with `}<inlineCode parentName="p">{`/asset_report/create`}</inlineCode>{` and then fetch the new Asset Report.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "data_quality_check_failed"
    }}><strong parentName="h4">{`DATA_QUALITY_CHECK_FAILED`}</strong></h4>
    <ErrorReference type='ASSET_REPORT_ERROR' error='DATA_QUALITY_CHECK_FAILED' subtitle='' server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-6"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`The extracted data from the financial institution showed signs of poor data quality, preventing the generation of an accurate report.`}</li>
      </ul>
      <Checkbox checklistId='DATA_QUALITY_CHECK_FAILED' mdxType="Checkbox">
        <p>{`Try creating the Asset Report again 1-2 days later.`}</p>
      </Checkbox>
    </ErrorReference>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "product_not_enabled",
        level: 4,
        title: "PRODUCT_NOT_ENABLED",
      },
{
        id: "data_unavailable",
        level: 4,
        title: "DATA_UNAVAILABLE",
      },
{
        id: "product_not_ready",
        level: 4,
        title: "PRODUCT_NOT_READY",
      },
{
        id: "asset_report_generation_failed",
        level: 4,
        title: "ASSET_REPORT_GENERATION_FAILED",
      },
{
        id: "invalid_parent",
        level: 4,
        title: "INVALID_PARENT",
      },
{
        id: "insights_previously_not_enabled",
        level: 4,
        title: "INSIGHTS_PREVIOUSLY_NOT_ENABLED",
      },
{
        id: "data_quality_check_failed",
        level: 4,
        title: "DATA_QUALITY_CHECK_FAILED",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
